/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { HiOutlineChevronUp } from '@react-icons/all-files/hi/HiOutlineChevronUp'
import { useSearchParams } from 'react-router-dom'
import ModalFeedback from './modals/ModalFeedback'

const Footer = () => {
	const [showFeedbackModal, setShowFeedbackModal] = useState(false)
	const [searchParams] = useSearchParams()
	const leaveFeedback = searchParams.get('leaveFeedback')

	useEffect(() => {
		if (leaveFeedback === 'yes') {
			setShowFeedbackModal(true)
		}
	}, [leaveFeedback])

	const goToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}

	return (
		<footer className="relative">
			<div className="flex items-center justify-center mt-8 pb-5">
				<a
					className="footer-logo-link"
					rel="noreferrer"
					href="https://www.pttplc.com/en/Home.aspx"
					target="_blank"
				>
					<img
						alt="PTT"
						src={`${process.env.REACT_APP_BASE_ASSETS}/uploads/logos/logo-ptt.jpg`}
					/>
				</a>

				<a
					className="footer-logo-link"
					rel="noreferrer"
					href="https://www.pttgcgroup.com/en/home"
					target="_blank"
				>
					<img
						alt="GC"
						src={`${process.env.REACT_APP_BASE_ASSETS}/uploads/logos/logo-gc.jpg`}
					/>
				</a>

				<a
					className="footer-logo-link"
					rel="noreferrer"
					href="https://www.thaioilgroup.com/home/default.aspx?lang=en"
					target="_blank"
				>
					<img
						alt="Thaioil"
						src={`${process.env.REACT_APP_BASE_ASSETS}/uploads/logos/logo-thaioil.jpg`}
					/>
				</a>

				<a
					className="footer-logo-link"
					rel="noreferrer"
					href="https://www.irpc.co.th/en/en-hotnews/"
					target="_blank"
				>
					<img
						alt="IRPC"
						src={`${process.env.REACT_APP_BASE_ASSETS}/uploads/logos/logo-irpc.jpg`}
					/>
				</a>

				<a
					className="footer-logo-link"
					rel="noreferrer"
					href="https://www.pttor.com/en"
					target="_blank"
				>
					<img
						className="w-20"
						alt="OR"
						src={`${process.env.REACT_APP_BASE_ASSETS}/uploads/logos/logo-or.png`}
					/>
				</a>
			</div>

			{/* <div className="border-t border-borderLight pt-5 text-center">
				<a className="mx-3">Privacy Center</a>
				<a className="mx-3">Site Map</a>
			</div> */}

			{/* <div className="mt-5 pb-3 text-center">
				<p>
					<strong>PTT Public Company Limited</strong>
				</p>
				<p className="mt-1">
					555 Vibhavadi Rangsit Road, Chatuchak Bangkok 10900 Thailand
				</p>
			</div> */}

			<div className="flex flex-col text-white mt-5 px-4 py-3 bg-gradient-to-r from-ci2 via-ci2 to-ci1 md:flex-row md:items-center md:justify-between">
				<div className="flex items-center">
					<img
						alt=""
						src={`${process.env.REACT_APP_BASE_ASSETS}/uploads/logos/logo-ptt.svg`}
						className="w-20"
					/>
					<div className="border-l border-l-white ml-3 pl-3">
						<strong>PTT Public Company Limited</strong>
						<br />
						555 Vibhavadi Rangsit Road, <br className="lg:hidden" />
						Chatuchak Bangkok 10900
					</div>
				</div>

				<div className="mt-3 md:mt-0">
					<a onClick={() => setShowFeedbackModal(true)}>Leave Your Feedback</a>
					<span className="mx-3">|</span>
					<a
						href="https://pttpdpa.pttplc.com/Privacy/213214"
						target="_blank"
						rel="noreferrer"
					>
						Privacy Center
					</a>
					{/* <a className="mx-3">Site Map</a> */}
				</div>
			</div>

			<a
				onClick={goToTop}
				className="bg-ci2 rounded-full bottom-2 shadow-lg text-white p-3 absolute right-2 hover:text-white md:bottom-20 md:right-5"
			>
				<HiOutlineChevronUp size={20} />
			</a>

			{showFeedbackModal && (
				<ModalFeedback handleCloseModal={() => setShowFeedbackModal(false)} />
			)}
		</footer>
	)
}

export default Footer
